<section class="cue-section cue-section--status">
	<div class="cue-step-icon" aria-hidden="true">
		<i [class]="statusIcon"></i>
	</div>

	<div class="cue-step-content">
		<span class="cue-step-label">1. Estado del cuaderno</span>
		<h4>{{ currentStatusText }}</h4>
		<p>{{ statusDescription }}</p>
	</div>

	@if (statusCue) {
		<p-tag [value]="statusLabel" [severity]="statusSeverity" [rounded]="true"></p-tag>
	}
</section>
